import { Box, Button, Typography } from '@mui/material';
import React from 'react';

interface LabelNavProps {
  position: number | null;
  total: number;
  onPrevious: () => void;
  onNext: () => void;
}

const navButtonSx = { whiteSpace: 'nowrap', flexShrink: 0 };

const LabelNav: React.FC<LabelNavProps> = ({ position, total, onPrevious, onNext }) => {
  const navDisabled = total === 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
      <Button
        variant="outlined"
        size="small"
        sx={navButtonSx}
        onClick={onPrevious}
        disabled={navDisabled}
      >
        Previous label
      </Button>
      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
        {total === 0 ? 'No labels' : `Label ${position ?? '–'} of ${total}`}
      </Typography>
      <Button
        variant="outlined"
        size="small"
        sx={navButtonSx}
        onClick={onNext}
        disabled={navDisabled}
      >
        Next label
      </Button>
    </Box>
  );
};

export default LabelNav;
